document.addEventListener('DOMContentLoaded', () => {
    const video = document.getElementById('video_banner_customVideo_id');
    const playIcon = document.getElementById('slideshow__video-action-play');
    const pauseIcon = document.getElementById('slideshow__video-action-pause');
    const soundOnIcon = document.getElementById('slideshow__icon-sound-on');
    const soundOffIcon = document.getElementById('slideshow__icon-sound-off');
    let isUserPaused = false;

    function updatePlayButton() {
        if (video.paused) {
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        } else {
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'block';
        }
    }

    window.play_pause_button = function () {
        isUserPaused = !video.paused;
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
        updatePlayButton();
    };

    window.sound_button = function () {
        video.muted = !video.muted;
        soundOnIcon.style.display = video.muted ? 'none' : 'block';
        soundOffIcon.style.display = video.muted ? 'block' : 'none';
    };

    video.muted = true;
    updatePlayButton();
    soundOnIcon.style.display = 'none';
    soundOffIcon.style.display = 'block';
    video.play().catch(() => {
        updatePlayButton();
    });

    let throttleTimeout = null;
    window.addEventListener('scroll', () => {
        if (!throttleTimeout) {
            throttleTimeout = setTimeout(() => {
                const rect = video.getBoundingClientRect();
                const inView = rect.top < window.innerHeight && rect.bottom > 0;
                if (!inView && !video.paused) {
                    video.pause();
                    updatePlayButton();
                } else if (inView && video.paused && !isUserPaused) {
                    video.play();
                    updatePlayButton();
                }
                throttleTimeout = null;
            }, 100);
        }
    });

    video.addEventListener('play', updatePlayButton);
    video.addEventListener('pause', updatePlayButton);
});
